// extracted by mini-css-extract-plugin
export default {"root":"G3gqxnRcsC","stepNavigation":"Is4o0Z0Wtk","arrowContainer":"yXdo2tMoma","arrowContainer_left":"K5r_mzCjuE","arrowContainer_right":"o9CHNxfTZG"};